const works = [
  {
    id: 1,
    image: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=487,fit=crop/A0xVvobDbRIBrVE7/tailing-dams-liner-mk39EqeW8bFEE14P.png',
    alt: 'Soldagem geomembrana — revestimento de barragem',
    label: 'Revestimento de Barragem',
  },
  {
    id: 2,
    image: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=487,fit=crop/A0xVvobDbRIBrVE7/hdpe-liner-26-Aq2okqLPjOSgDPWk.png',
    alt: 'Instalação liner HDPE em reservatório',
    label: 'Liner HDPE em Reservatório',
  },
  {
    id: 3,
    image: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=487,fit=crop/A0xVvobDbRIBrVE7/hdpe-liner-21-ALpol7annKiOZx7j.png',
    alt: 'Obra de impermeabilização com geomembrana',
    label: 'Impermeabilização em Obra',
  },
];

export default function PortfolioSection() {
  return (
    <section id="videos" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="text-green-500 text-xs uppercase tracking-widest mb-2 block">Portfólio</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 mb-3 uppercase leading-none">
            TRABALHOS<br />REALIZADOS
          </h2>
          <p className="text-gray-500 text-sm max-w-md mx-auto">
            Projetos de soldagem de geomembrana executados com nossas máquinas pelo Brasil e Argentina
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {works.map((work) => (
            <div key={work.id} className="group relative w-full h-60 rounded-2xl overflow-hidden">
              <img
                alt={work.alt}
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                src={work.image}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <span className="text-white text-sm">{work.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
